import { createStyles, Group, ScrollArea, Stack, Title } from '@mantine/core';
import { fontsizesNum } from '@styles/fonts/fontsizes/fontsizes.styles';
import { forwardRef } from 'react';
import { TagNum } from '../TagNum/TagNum';
import { TagCategoryList } from './TagCategoryList';
import { groupTags, PossibleTagsVal, toGroupTagsArgs } from './TagDialog.utils';
import { TagDialogHoverProps } from './TagDialogHover';

interface TagDialogProps<T extends unknown[]>
  extends Pick<
    TagDialogHoverProps<T>,
    'deleteHandler' | 'deleteHandlerArgs' | 'calcTagProps'
  > {
  tags: PossibleTagsVal;
  rowNum: number | string;
}
export const useTagDiagStyles = createStyles(() => {
  const innerWidth = 246;
  return {
    dropdown: {
      padding: '16px 24px',
      paddingBottom: 0,
      cursor: 'auto',
      maxHeight: 450,
      // overflow: 'auto', -- !overflow breaks arrow.
    },
    dialog_wrap: {
      // padding-dropdown: add to it.
      paddingBottom: '16px',
    },

    // In cases like this, you must specify a fixed width for the scroll area
    scrollbar_wrap: {
      '& > *': {
        maxWidth: innerWidth,
      },
    },
    cat_stack: {
      // And provide a fixed width for the inside to avoid overflow
      maxWidth: innerWidth,
    },
  };
});
export function FWTagDialog<T extends unknown[]>(
  props: TagDialogProps<T>,
  ref: React.ForwardedRef<HTMLDivElement>,
): JSX.Element {
  const { tags, rowNum, calcTagProps, ...dHandler } = props;
  const [grouped, categoryList] = groupTags(...toGroupTagsArgs(tags));
  const { classes } = useTagDiagStyles();

  const categories = categoryList.map(each => {
    const grp = grouped[each];
    const { tags: _tags, categoryName } = grp;
    return (
      <TagCategoryList
        key={each}
        tags={_tags}
        categoryName={categoryName}
        calcTagProps={calcTagProps}
        {...dHandler}
      />
    );
  });

  const limitedNum = rowNum > 1000 ? '999+' : rowNum;
  return (
    <Stack ref={ref} spacing={fontsizesNum.lg} className={classes.dialog_wrap}>
      <Group spacing={10} align="center">
        <Title order={5} weight={600}>
          Tags
        </Title>
        <TagNum>{limitedNum}</TagNum>
      </Group>
      <ScrollArea.Autosize
        className={classes.scrollbar_wrap}
        type="hover"
        maxHeight={319}
      >
        <Stack className={classes.cat_stack} spacing={fontsizesNum.md}>
          {categories}
        </Stack>
      </ScrollArea.Autosize>
    </Stack>
  );
}

export const TagDialog = forwardRef(FWTagDialog);
